import classNames from 'classnames'
import { motion, Variants } from 'framer-motion'

import { ImageComponent } from '@apps-common/components/common'
import { useGetDefaultSiteImage } from '@apps-common/hooks/useGetDefaultSiteImage'
import { IMMSiteListModel } from '@apps-common/types/my-monitoring'

const childVariants: Variants = {
  initial: {
    opacity: -1,
    scale: 0.85,
    bottom: '-120px',
    transition: {
      ease: 'easeInOut',
      when: 'afterChildren',
      duration: 0.2
    }
  },
  animate: {
    opacity: 1,
    scale: 1,
    bottom: '0px',
    transition: {
      ease: 'easeInOut',
      duration: 0.2
    }
  },
  exit: {
    opacity: -1,
    scale: 0.85,
    bottom: '-120px',
    transition: {
      ease: 'easeInOut',
      when: 'afterChildren',
      duration: 0.2
    }
  }
}

interface IProps {
  selectedSite?: string
  site: IMMSiteListModel
  callback: (site: IMMSiteListModel) => void
}

export const SiteSelectItem: React.FC<IProps> = ({ selectedSite, site, callback }) => {
  const { defaultImageUrl } = useGetDefaultSiteImage(site.siteId)

  return (
    <motion.button
      type='button'
      key={`site-select-item-inner-${site.siteId}`}
      variants={childVariants}
      aria-label={site.siteName || `Selected site ${site.accountNo}`}
      className={classNames(
        'bg-surface text-text border border-border/90 p-[5px] rounded-2xl text-right',
        site.unitId === selectedSite && 'ring-[2px] ring-mm-brand/60'
      )}
      onClick={() => callback(site)}
    >
      <div className='flex items-center justify-between gap-[10px] pr-[10px]'>
        <ImageComponent
          src={site.siteImageUrl || defaultImageUrl}
          alt={site.siteName || `Selected site ${site.accountNo}`}
          imageClasses='min-w-[100%] min-h-[100%] object-cover bg-text/20'
          containerClasses='bg-text/20 rounded-xl overflow-hidden w-[35px] min-w-[35px] h-[35px] min-h-[35px]'
          errorIconClasses='w-[33px] min-w-[33px] h-[33px] min-h-[33px]'
          ignoreContainerOnError
        />
        <div className='jost text-[0.8rem] leading-[1.1rem] line-clamp-2'>{site?.siteName || `No details - Acc# ${site?.accountNo}`}</div>
      </div>
    </motion.button>
  )
}
